// ============================================================
// FYUNOR — US Payroll Taxes (FICA)
// Social Security and Medicare calculation helpers.
// ============================================================

import { FILING_STATUS } from "./constants";

// --- Social Security (2026) ---
export const SOCIAL_SECURITY = {
  rate: 0.062,
  wageBase: 184500,
};

// --- Medicare (2026) ---
export const MEDICARE = {
  rate: 0.0145,
  additionalRate: 0.009,
  additionalThreshold: {
    [FILING_STATUS.SINGLE]: 200000,
    [FILING_STATUS.MARRIED_JOINTLY]: 250000,
    [FILING_STATUS.MARRIED_SEPARATELY]: 125000,
    [FILING_STATUS.HEAD_OF_HOUSEHOLD]: 200000,
  },
};

// --- Helpers ---

/** Social Security tax: 6.2% of wages up to the annual wage base. */
export function calcSocialSecurity(wages) {
  const ssWages = Math.min(Math.max(0, wages), SOCIAL_SECURITY.wageBase);
  return ssWages * SOCIAL_SECURITY.rate;
}

/** Medicare tax: 1.45% of all wages plus 0.9% above the threshold. */
export function calcMedicare(wages, filingStatus) {
  const gross = Math.max(0, wages);
  const base = gross * MEDICARE.rate;
  const threshold = MEDICARE.additionalThreshold[filingStatus] ?? MEDICARE.additionalThreshold[FILING_STATUS.SINGLE];
  const additional = Math.max(0, gross - threshold) * MEDICARE.additionalRate;
  return base + additional;
}

/** Combined FICA (Social Security + Medicare) for a set of wages. */
export function calcFICA(wages, filingStatus) {
  const socialSecurity = calcSocialSecurity(wages);
  const medicare = calcMedicare(wages, filingStatus);
  return { socialSecurity, medicare, total: socialSecurity + medicare };
}